import React from "react";

export const ViewBox = ({ children, label, obligatorily, className = "", id }) => {
  return (
    <div id={id} className={`w-full ${className}`}>
      {label && (
        <div className="flex items-center gap-1.5 mb-2.5">
          <span className="text-sm sm:text-base font-bold text-gray-900 tracking-tight">
            {label}
          </span>
          {obligatorily && <span className="text-red-500 font-bold">*</span>}
        </div>
      )}
      <div className="bg-[#F8F9FB] border border-[#EEEEF2] rounded-2xl p-4 sm:p-5 space-y-4 shadow-sm">
        {children}
      </div>
    </div>
  );
};
